import React from 'react';
import { NumericInput, Pane, PropertyGrid, Slider, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ns } from '@leverege/i18n';
import ImageGraphBackgroundModel from "../../models/background/ImageGraphBackgroundModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.ImageGraphBackgroundEditor');
export default function ImageGraphBackgroundEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(ImageGraphBackgroundModel, props);
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "glyphEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('baseColor')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: ImageGraphBackgroundModel.getBackgroundColor(value),
    eventData: "setBackgroundColor",
    onChange: onModelChange,
    hint: t('baseColorHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('imageURL')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: ImageGraphBackgroundModel.getImageUrl(value),
    eventData: "setImageUrl",
    onChange: onModelChange,
    hint: t('imageURLHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('imageWidth')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: ImageGraphBackgroundModel.getImageWidth(value),
    eventData: "setImageWidth",
    onChange: onModelChange,
    hint: t('imageWidthHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('imageHeight')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: ImageGraphBackgroundModel.getImageHeight(value),
    eventData: "setImageHeight",
    onChange: onModelChange,
    hint: t('imageHeightHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('imageX')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: ImageGraphBackgroundModel.getImageX(value),
    eventData: "setImageX",
    onChange: onModelChange,
    hint: t('imageXHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('imageY')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: ImageGraphBackgroundModel.getImageY(value),
    eventData: "setImageY",
    onChange: onModelChange,
    hint: t('imageYHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('imageOpacity')
  }, /*#__PURE__*/React.createElement(Slider, {
    min: 0,
    max: 100,
    value: ImageGraphBackgroundModel.getImageOpacity(value),
    eventData: "setImageOpacity",
    onChange: onModelChange,
    hint: t('imageOpacityHint')
  })));
}